import { CloudinaryImageViewModel } from '@api/models/CloudinaryImageViewModel';
import { StyledImage } from '@components/views/homepage/components/MostPreferredHotels/Item/styled';

import {
  CampaignCardSubTitle,
  CampaignCardTitle,
  CampaignImgWrapper,
  CampaignSpecialImg,
  CampaignTitleContainer,
  InfoWrapper,
  CampaignVerticalLine,
} from './CampaignCardStyles';

type ICampaignProps = {
  id: string;
  title?: string;
  subTitle?: string;
  images: Array<CloudinaryImageViewModel>;
  campaignImages?: Array<CloudinaryImageViewModel>;
  url: string;
  name?: string;
  showPriority?: boolean;
};

export type ICampaignCardProps = ICampaignProps;

const CampaignCard = ({
  title,
  subTitle,
  images,
  campaignImages,
  name,
  showPriority,
}: ICampaignCardProps) => {
  return (
    <CampaignImgWrapper>
      {images?.map((image: CloudinaryImageViewModel) =>
        showPriority ? (
          <StyledImage
            priority={true}
            key={image.url}
            src={image.url || ''}
            alt={image.alt || name || ''}
            width={500}
            height={400}
          />
        ) : (
          <StyledImage
            priority={false}
            key={image.url}
            src={image.url || ''}
            alt={image.alt || name || ''}
            width={500}
            height={400}
            loading='lazy'
          />
        )
      )}
      {title || subTitle ? (
        <InfoWrapper>
          <CampaignTitleContainer>
            <CampaignVerticalLine />
            <CampaignCardTitle subTitleAvailable={subTitle ? true : false}>
              {title}
              <CampaignCardSubTitle>{subTitle}</CampaignCardSubTitle>
            </CampaignCardTitle>
          </CampaignTitleContainer>
        </InfoWrapper>
      ) : null}

      {campaignImages?.map((campaignImage: CloudinaryImageViewModel) => (
        <CampaignSpecialImg
          key={campaignImage.url}
          img={campaignImage.url || ''}
        />
      ))}
    </CampaignImgWrapper>
  );
};

export default CampaignCard;
